import { QuoteServiceApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { SaveItemsAction } from '../context/SmartSendContextModels';
import { ApplierOption } from './ApplierOption';
import { RemoveOffset } from './DateHelper';
import { changedDimensionFields, reflowConsignmentDimensions } from './SmartSendBulkActionApplier';

export function SmartSendSingleActionApplier(item: SmartSendItemApiModel, action: SaveItemsAction): string[] {
  const amended = [];

  const actions = action.payload.actions || [];
  const canApply = (x: ApplierOption) => actions.includes(x) && !!action.payload.changes[x];

  if (canApply('Meta')) {
    amended.push('Meta');
    for (const p in action.payload.changes.Meta) {
      item.Meta[p] = action.payload.changes.Meta[p];
    }
  }

  if (canApply('Dimensions')) {
    amended.push('Dimensions');

    // Which axes actually MOVED, compared before the write. dimensionKeysToParcelFields would report all
    // four, because this path hands over a whole Dimensions object rather than the partial payload a
    // socket update carries - so every save that touched dimensions overwrote the per-parcel L/W/H too.
    const changedFields = changedDimensionFields(item.PackageDimensions, action.payload.changes.Dimensions);
    item.PackageDimensions = action.payload.changes.Dimensions;

    // A consignment item's ITEM-WEIGHT is raised from the PARCEL weights, so writing PackageDimensions
    // alone left the error it was raised for still raised - the weight quick fix appeared to do nothing
    // on exactly the items most likely to need it. The bulk applier and the socket reducer already
    // reflow; this path did not.
    //
    // Only when the action does not carry its own Consignment: if it does, that plan is the authority and
    // was built from the user's per-parcel edits. Reflowing over it would redistribute those away, and the
    // Consignment block below would then have to undo the damage by assignment order alone.
    if (!actions.includes('Consignment') && reflowConsignmentDimensions(item, changedFields)) {
      amended.push('Consignment');
    }
  }

  if (actions.includes('Consignment')) {
    amended.push('Consignment');
    item.Consignment = action.payload.changes.Consignment;
  }

  if (canApply('Sender')) {
    amended.push('Sender');
    amended.push('Tags');
    item.Sender = action.payload.changes.Sender;
  }

  if (canApply('Recipient')) {
    amended.push('Recipient');
    item.Recipient = action.payload.changes.Recipient;
  }

  if (canApply('Service')) {
    amended.push('Service');
    const s = action.payload.changes.Service as QuoteServiceApiModel;

    item.Service = {
      Name: s.Name,
      Id: s.Id,
      Provider: s.Provider,
      AccountId: s.AccountId,
      Meta: null
    };
  }

  if (canApply('MarketplaceOrderLines')) {
    amended.push('MarketplaceOrderLines');
    item.MarketplaceOrderLines = action.payload.changes.MarketplaceOrderLines;
  }

  if (canApply('Extras') || canApply('Protection')) {
    amended.push('Extras');
    item.Extras = action.payload.changes.Extras;
  }

  if (canApply('PreferredCollectionDate')) {
    amended.push('PreferredCollectionDate');
    item.PreferredCollectionDate = RemoveOffset(action.payload.changes.PreferredCollectionDate as Date);
  }

  if (canApply('ServiceOption')) {
    if (action.payload.changes.ServiceOption.Extras) {
      amended.push('ServiceOption');
      item.Extras = action.payload.changes.ServiceOption.Extras.map((e) => {
        return { Id: e.Id, Name: e.Name, Provider: e.Provider };
      });
    }
  }
  return amended;
}
